import React, { useContext } from "react";
import style from "@styles/profile/transaction.module.css";
import { Store } from "@utils/store/ContextStore";
import { useState } from "react";
import { useEffect } from "react";
import { getTransaction } from "@queries/user.queries";
import TItems from "./TItems";
import { Modal } from "@mui/material";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroll-component";
import Box from "@mui/material/Box";
import Image from "next/legacy/image";
import playStoreImage from "../../public/assets/onboardingImages/playStoreImage1.png";
import fastDeliveryAnimation from "@public/assets/Lottie/delivery.json";
import logo from "@public/logo.webp";
import dynamic from "next/dynamic";
import Link from "next/link";
import EnterMail from "@components/modal/EnterMail";
import { useRouter } from "next/router";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import UtsavNewModal from "src/globalModule/views/UtsavNewModal";
const Lottie = dynamic(() => import("lottie-react"), {
  ssr: false
});
const Transtation = ({
  userDetail
}) => {
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  const [mOpen, setMOpen] = useState(false);
  const [tDetails, setTDetails] = useState({});
  const [userT, setUserT] = useState();
  const [hasMore, setHasMore] = useState(true);
  const [openMailModal, setOpenMailModal] = useState(false);
  const router = useRouter();
  const currentUserUid = loggedInUser?.uid;
  const urlUserUid = router?.query?.params[0];
  const [errorModal, setErrorModal] = useState({
    open: false,
    heading: "",
    message: "",
    acceptMethod: () => {},
    icon: null,
    positive: false
  });
  // when there is a query param in the url, it means that the user is trying to see the transaction of another user
  // so we check if the current user is the same as the user in the url

  if (router?.query?.registrationID) {
    if (currentUserUid !== urlUserUid) {
      // swal.fire({
      //   title: "Sorry! You can only see your own transaction",
      //   icon: "warning",
      //   background: "#f2f2f2",
      //   backdrop: "rgba(34, 34, 34, 0.4);",
      //   customClass: {
      //     title: `${modalClasses.modalCard__heading1}`,
      //     htmlContainer: `${modalClasses.modalCard__msg1}`,
      //     actions: `${modalClasses.modalCard__options1} `,
      //     cancelButton: `${modalClasses.modalCard__btn1} ${modalClasses.modalCard__btn_neg1}`,
      //     confirmButton: `${modalClasses.modalCard__btn1} ${modalClasses.modalCard__btn_pos1}`,
      //     icon: `${modalClasses.modalCard__icon1}`,
      //   },
      // });
      setErrorModal({
        open: true,
        heading: "Warning",
        message: "Sorry! You can only see your own transaction",
        acceptMethod: () => {
          setErrorModal({
            ...errorModal,
            open: false
          });
          router.push("/home");
        },
        icon: <InfoOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
    }
  }
  useEffect(() => {
    const fetchData = async cancelToken => {
      const data = await getTransaction({
        uid: loggedInUser.uid,
        accessToken: loggedInUser.accessToken,
        cancelToken
      });
      setUserT(data.data);
    };
    const source = axios.CancelToken.source();
    fetchData(source.token);
    if (router?.query?.registrationID) {
      setOpenMailModal(true);
    }
    return () => {
      if (source) source.cancel();
    };
  }, [loggedInUser]);
  const updateData = async () => {
    const lastTs = userT[userT.length - 1]?.ts;
    if (!lastTs) return () => {};
    const data = await getTransaction({
      uid: loggedInUser.uid,
      accessToken: loggedInUser.accessToken,
      ts: lastTs
    });
    if (data?.data?.length > 0) {
      setUserT(cur => [...cur, ...data.data]);
    } else {
      setHasMore(false);
    }
  };
  function ModelOpen() {
    return <>
        <Modal open={mOpen} onClose={() => setMOpen(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" data-sentry-element="Modal" data-sentry-source-file="Transaction.jsx">
          <Box sx={{
          boxShadow: 24
        }} className={style.mModal} data-sentry-element="Box" data-sentry-source-file="Transaction.jsx">
            <div className={style.mBody}>
              <p className={style.mBodyHead}>
                To track your Puja update & Prasad delivery status,
              </p>
              <p className={style.mBodyHead1}>Download Utsav App Now.</p>
              <Lottie animationData={fastDeliveryAnimation} loop={true} className={style.mBodyAnimation} data-sentry-element="Lottie" data-sentry-source-file="Transaction.jsx" />
              <div className={style.donationItems}>
                <div className={style.donationHeading}>
                  <div className={style.form_logo}>
                    <Image src={logo} alt="Utsav Logo" priority data-sentry-element="Image" data-sentry-source-file="Transaction.jsx" />
                  </div>
                  <div className={style.form_name}>
                    <p className={style.form_logo_name}>Utsav</p>
                  </div>
                </div>
                <div className={style.section1_download}>
                  <Link href="https://play.google.com/store/apps/details?id=com.applex.utsav" className={style.section1_download_link} target="blank" rel="alternate" hrefLang={router.locale} data-sentry-element="Link" data-sentry-source-file="Transaction.jsx">
                    <Image src={playStoreImage} alt="Utsav Playstore Donwload Image" className={style.section1_download_link_img} data-sentry-element="Image" data-sentry-source-file="Transaction.jsx" />
                  </Link>
                </div>
              </div>
            </div>
          </Box>
        </Modal>
      </>;
  }
  return <div className={style.tContainer} data-sentry-component="Transtation" data-sentry-source-file="Transaction.jsx">
      {userT && <InfiniteScroll dataLength={userT.length} next={updateData} hasMore={hasMore}>
          <>
            {userT.map(e => <Item key={e.registrationID} data={e} userDetail={userDetail} onClickHandler={() => {
          setMOpen(true);
          setTDetails(e);
        }} onClose={() => setMOpen(false)} />)}
          </>
        </InfiniteScroll>}

      <ModelOpen data-sentry-element="ModelOpen" data-sentry-source-file="Transaction.jsx" />
      {openMailModal && currentUserUid === urlUserUid && <EnterMail open={openMailModal} onClose={() => {
      setOpenMailModal(false);
    }} registrationID={router?.query?.registrationID
    // ? router?.query?.registrationID
    // : data.registrationID
    } userDetail={userDetail} />}
      {errorModal.open && <UtsavNewModal open={errorModal.open} toggleModal={() => setErrorModal(prevState => ({
      ...prevState,
      open: true
    }))} heading={errorModal.heading} message={errorModal.message} acceptMsg="Okay" onAccept={errorModal.acceptMethod}
    // rejectMsg="Cancel"
    icon={errorModal.icon} positive={errorModal.positive} />}
    </div>;
};
export default Transtation;
const Item = ({
  onClickHandler,
  data,
  userDetail
}) => {
  return <>
      <TItems onClickHandler={onClickHandler} userDetail={userDetail} data={data} data-sentry-element="TItems" data-sentry-source-file="Transaction.jsx" />
    </>;
};